import module from 'facturacion/configuracion/module.js'
import template from './template.html'

export class FacturacionConfiguracionConceptosEditarUnidadesmedidaComponent {
  onClose
  data = []
  descripcion = ''
  $promise = null

  constructor (FacturacionConfiguracionUnidadesMedida) {
    this.FacturacionConfiguracionUnidadesMedida = FacturacionConfiguracionUnidadesMedida
  }

  buscar () {
    if (this.descripcion) {
      this.$promise = this.FacturacionConfiguracionUnidadesMedida.get(this.descripcion)
        .then(({data}) => (this.data = data))
    } else {
      this.data = []
    }
  }

  seleccionar (item) {
    this.onClose({$event: {details: item}})
  }
}

module.component('facturacionConfiguracionConceptosEditarUnidadesmedida', {
  controller: FacturacionConfiguracionConceptosEditarUnidadesmedidaComponent,
  template,
  bindings: {
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/facturacion/configuracion/components/conceptos/editar/unidadesmedida/component.js